import React from 'react';
import styled from 'styled-components';
import {
  CpBody01Primary,
  CpBody02Primary,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpFooterSectionVariantWidgetProps } from '../types';
import {
  CopyWrightText,
  CpFooterSectionWrapper as CpFooterSectionWrapperAtom,
  LinkItem,
  LinksWrapper,
} from './cp-footer-without-link-groups';

const CpFooterSectionWrapper = styled(CpFooterSectionWrapperAtom)`
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: var(--cp-spacing-06);
  padding-top: var(--cp-spacing-07);
  border-top: solid 1px var(--cp-border-strong-auto-adjust);

  @media (max-width: 480px) {
    flex-direction: column;
    gap: var(--cp-spacing-03);
    padding-top: var(--cp-spacing-05);
  }
`;

export const LinkGroupSection = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: var(--cp-spacing-08);
  justify-content: space-between;

  @media (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
    margin-bottom: 0;
  }
`;

export const LinkGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: var(--cp-spacing-08);

  @media (max-width: 480px) {
    margin-bottom: var(--cp-spacing-06);

    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const LinkGroupTitle = styled(CpBody02Primary)`
  margin-bottom: var(--cp-spacing-06);
`;

export const LinkGroupItem = styled(CpBody01Primary)`
  margin-bottom: var(--cp-spacing-05);
  a {
    color: var(--cp-black-100);
  }
`;

export const CpFooterWithLinkGroupOnBottom: React.FC<CpFooterSectionVariantWidgetProps> =
  ({ disabled, data, widget }) => {
    const background = useGetBackground(widget);

    return (
      <CpFooterSectionWrapper
        paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
        isDisabled={disabled}
        background={background}
      >
        <LinkGroupSection>
          {data?.footerColumns?.map((fc) => (
            <LinkGroup>
              <LinkGroupTitle autoAdjustColor>{fc?.groupTitle}</LinkGroupTitle>
              {fc?.footerItems?.map((fi) => (
                <a href={fi?.link} target="_blank" rel="noreferrer">
                  <LinkGroupItem autoAdjustColor>{fi?.linkName}</LinkGroupItem>
                </a>
              ))}
            </LinkGroup>
          ))}
        </LinkGroupSection>

        <Wrapper>
          <CopyWrightText autoAdjustColor>{data.copyright}</CopyWrightText>

          <LinksWrapper>
            <a href={data?.link1} target="_blank" rel="noreferrer">
              <LinkItem autoAdjustColor>{data?.linkName1}</LinkItem>
            </a>
            <a href={data?.link2} target="_blank" rel="noreferrer">
              <LinkItem autoAdjustColor>{data?.linkName2}</LinkItem>
            </a>
          </LinksWrapper>
        </Wrapper>
      </CpFooterSectionWrapper>
    );
  };
